import { FC, memo } from 'react';
import { Button, ButtonProps } from '@mui/material';

const MemoizedButton: FC<ButtonProps> = (props) => {
  return <Button {...props} />;
};

export default memo(MemoizedButton);
